module.exports = __webpack_public_path__ + "img/SC4-Debt.d108a3c1.svg";